import React from 'react';
import VirgyMascot from './VirgyMascot';

/**
 * Calm empty-state widget. Drops Virgy in to make a "nothing here yet" moment
 * feel intentional instead of empty. Keep copy short: one title + one optional
 * hint line. For dense list contexts use the `compact` variant.
 */
export default function EmptyState({ title, hint, compact = false, action = null, mascotSize }) {
  const size = mascotSize ?? (compact ? 34 : 56);
  return (
    <div className={`flex flex-col items-center text-center ${compact ? 'py-6' : 'py-12'}`}>
      <VirgyMascot size={size} className="opacity-90" />
      {title && (
        <div className={`mt-3 ${compact ? 'text-[13px]' : 'text-[14.5px]'} text-[hsl(var(--text-soft))]`}>
          {title}
        </div>
      )}
      {hint && (
        <div className={`mt-1 ${compact ? 'text-[11.5px]' : 'text-[12.5px]'} text-[hsl(var(--text-muted))]`}>
          {hint}
        </div>
      )}
      {action && <div className="mt-3">{action}</div>}
    </div>
  );
}
